<template>
  <div class="inner">
    <div class="close icon-cross-circle" @click="close"></div>
    <form v-if="!showResponse" class="contact-form" method="post" @submit.prevent.stop="send">
    
    <label class="small" for="contact-subject-field">Subject</label>
    <select name="subject" v-model="subject" id="contact-subject-field">
      <option
        v-for="(subOpt, si) in subjects"
        :key="[subOpt.key,si].join('_')"
        :value="subOpt.key"
      >{{subOpt.value}}</option>
    </select>
    <label class="small" for="contact-name-field">Contact name</label>
    <input
      v-model="contactName"
      type="text"
      maxlength="255"
      size="64"
      required="true"
      class="textfield plain-text"
      placeholder="Your name / organisation"
      id="contact-name-field"
    />
    <label class="small" for="contact-email-field">E-mail</label>
    <input
      v-model="email"
      type="email"
      maxlength="255"
      size="64"
      class="textfield mail"
      placeholder="Contact email address"
      id="contact-email-field"
    />
    <label class="small" for="contact-body-field">Message</label>
    <textarea
      rows="6"
      cols="64"
      v-model="body"
      class="textfield multi-line"
      placeholder="Write a message..."
      id="contact-body-field"
    ></textarea>
    <ul v-if="error" class="error messages">
      <li v-for="(msg, eri) in errorMsgs" :key="['error-msg',eri].join('_')">{{msg}}</li>
    </ul>
    <button v-if="maySubmit" type="submit" class="button submit">
      <i class="icon-send"></i>
      <span class="text">Send</span>
    </button>
  </form>
  <div v-if="showResponse" class="response" v-html="responseText"></div>
  </div>
</template>
<script type="text/javascript">
export default {
  name: "contact",
  props: {
    active: {
      type: Boolean,
      default: false
    }
  },
  data: function() {
    return {
      apiKey: "9_-Wrj38ow",
      remote: "/mail.php",
      contactName: "",
      subject: "_",
      email: "",
      body: "",
      subjects: [
        { key: "_", value: "... Select a subject..." },
        { key: "development", value: "Custom Web development" },
        { key: "new_service", value: "New Web service" },
        { key: "new_feature", value: "New feature for existing site" },
        { key: "bug_fix", value: "Fix for my site" }
      ],
      errorMsgs: [],
      showResponse: false,
      responseText: ""
    };
  },
  created() {
    if (window.location.href.indexOf("localhost:") > 0) {
      this.remote = "http://localhost:5444/api/mail.php";
    }
  },
  watch: {
    active(cv, pv) {
      if (cv !== pv) {
        if (!cv) {
          this.showResponse = false;
        }
      }
    }
  },
  computed: {
    error() {
      return this.errorMsgs.length > 0;
    },
    maySubmit() {
      return this.hasEnteredData && this.validate();
    },
    hasEnteredData() {
      if (this.active) {
        return this.body.trim().length > 4;
      }
      return false;
    },
    subjectLine() {
      let str = "";
      const matched = this.subjects.find(s => s.key === this.subject);
      if (matched) {
        str = matched.value;
      }
      return str;
    }
  },
  methods: {
    validate() {
      this.errorMsgs = [];
      if (this.hasEnteredData) {
        if (this.contactName.trim().length < 3) {
          this.errorMsgs.push(
            "Please enter a contact name. (min. 3 characters)"
          );
        }
        if (this.body.trim().length < 10) {
          this.errorMsgs.push(
            "Please enter a message with at least 10 characters"
          );
        }
        this.email = this.email.trim();
        const emailValid =
          this.email.length > 5 && /[^@]+@\w+/.test(this.email);
        if (!emailValid) {
          this.errorMsgs.push("Please enter a valid email");
        }
        if (this.subject.length < 4) {
          this.errorMsgs.push("Please select a subject");
        }
      }
      return this.errorMsgs.length < 1;
    },
    send() {
      const key = btoa(
        this.apiKey
          .split("")
          .reverse()
          .join("")
      );
      const params = {
        sec: key,
        fullname: this.contactName.trim(),
        from: this.email,
        subject: this.subjectLine,
        body: this.body
      };
      this.$http
        .post(this.remote, params)
        .then(response => {
          if (response.body) {
            const { body } = response;
            if (body.matched) {
              this.contactName = "";
              this.email = "";
              this.subject = "_";
              this.body = "";
              this.responseText = body.message;
              this.showResponse = true;
            }
          }
        })
        .catch(e => console.error(e));
    },
    close() {
      this.$parent.toggleContactPane("hide");
    }
  }
};
</script>


// WEBPACK FOOTER //
// Contact.vue?b56c12ac